import axios from 'axios';

/**
 * Dedicated axios instance for the SHOP back-office.
 * - Reads token from localStorage key `shop_admin_token`
 * - Sends 401s to the shop-admin login page on global failure
 */
export const shopApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

shopApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('shop_admin_token');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

shopApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && typeof window !== 'undefined') {
      const path = window.location.pathname;
      if (path.startsWith('/shop-admin') && path !== '/shop-admin/login') {
        localStorage.removeItem('shop_admin_token');
        window.location.href = '/shop-admin/login';
      }
    }
    return Promise.reject(err);
  },
);
